import { Component, EventEmitter, Input, OnInit, Output, DoCheck } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'ayen-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent implements OnInit, DoCheck {

  @Output() pageData = new EventEmitter();
  @Output() pageSize = new EventEmitter();
  @Output() pageChange = new EventEmitter();
  @Input() totalCount = 0;
  @Input() id = 'myPagination';
  @Input() pageTitle = '';
  @Input() itemsPerPage = 0;
  @Input() currentPage = 0;
  pageSizeValues: number[] = [20,25,50,75,100]
  selectedItem: number = this.pageSizeValues[0];
  totalPage: number = 0;
  myForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.myForm = this.fb.group({
      page: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.setDataForSelectSizePage()
    this.setTotalPage(this.itemsPerPage)
    this.updateFormPage();
  }

  ngDoCheck() {
    // Update form when currentPage input changes
    if (this.myForm.value.page !== this.currentPage) {
      this.updateFormPage();
    }
  }

  updateFormPage() {
    this.myForm.patchValue({
      page: this.currentPage,
    }, { emitEvent: false });
  }

  pageChanged(event: any) {
    this.pageData.emit(event);
  }

  pageSizeChanged(event: any) {
   this.pageSize.emit(event);
   this.setTotalPage(event)
  }
  
  setTotalPage(pageSize: number) {
    if (!pageSize || pageSize <= 0) return;

    const count = Number(this.totalCount) || 0;
    const size = Number(pageSize);
    const totalPages = Math.ceil(count / size);
  
    this.totalPage = totalPages;
  }

  setDataForSelectSizePage() {
    let index = this.pageSizeValues.findIndex((item) => {
      return item === this.itemsPerPage
    });
    if (index === -1) {
      this.pageSizeValues.push(this.itemsPerPage);
      this.pageSizeValues.sort((a, b) => a - b);
      this.selectedItem = this.itemsPerPage;
    } else {
      this.selectedItem = this.pageSizeValues[index];
    }
  }

  onSubmit() {
    if (this.myForm.valid) {
      this.pageChange.emit(this.myForm.value.page);
    }
  }

}
